<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="color"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Color">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            color: {
                get: function () {
                    return this.$store.getters.getNewCarColor
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarColor', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorColor
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/ColorInput.vue